export default "__VITE_ASSET__9hPXjvs0__"